// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images//edit.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/images//foundation_red.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/images//foundation.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../assets/images//accessories_red.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../assets/images//accessories.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../assets/images//walkAround_red.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../assets/images//walkAround.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../assets/images//maintenanceReminder_red.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../assets/images//maintenanceReminder.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../../assets/images//fixItRight_red.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../../assets/images//fixItRight.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../../assets/images//efficiency_red.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../../assets/images//efficiency.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../../assets/images//dpok_red.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../../assets/images//dpok.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("../../assets/images//toyota_way_red.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("../../assets/images//toyota_way.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("../../assets/images//customer_centricity_red.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("../../assets/images//customer_centricity.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("../../assets/images//employee_engagement_red.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("../../assets/images//employee_engagement.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("../../assets/images//business_sustainability_red.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("../../assets/images//business_sustainability.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("../../assets/images//Artboard 3down.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("../../assets/images//Artboard 3up.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.actionPlanContainer {
    margin-right: 0px !important;
    margin-left: 0px !important;
    margin-top: 1.7rem !important;
    font-size: 0.81rem;
    font-family: "Arial", sans-serif;
    max-width: none !important;
}

.activityDiv {
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    background-color: #F7F7F7;
}

.activityTabsHeader {
    color: black;
}

.activityTabsHeaderRed {
    padding-top: 1rem;
    /* margin-bottom:2rem;  */
}

.nav-tabs>li:first-child>a {
    border-top-left-radius: 1.25rem !important;
}

.nav-tabs>li:last-child>a {
    border-top-right-radius: 1.25rem !important;
}

.selectedCriteria {
    font-weight: bold;
}


.activityTabs .nav-item {
    width: 18% !important;
}

.activityTabs .tab-content {
    border-bottom-right-radius: 1.25rem;
    border-bottom-left-radius: 1.25rem;
    border-top-right-radius: 1.25rem;
    background-color: #f0f0f0;
    padding: 1.25rem;
    width: 100%;
    float: left;
    /*background: rgb(212, 210, 210);*/
}

.activityTabs .nav-tabs {
    opacity: 0.8;
}

.edit-icon-white {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    height: 28px;
    width: 28px;
    background-position: center;
    background-repeat: no-repeat;
    margin: 0 0.3rem;
}

.actionPlanContainer-toyota .foundation_icon {
    height: 40px;
    width: 40px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-repeat: no-repeat;
    margin-left: 18px !important;
    background-position: center;
    background-size: cover;
}

.actionPlanContainer-lexus .foundation_icon {
    height: 40px;
    width: 40px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    background-repeat: no-repeat;
    margin-left: 18px !important;
    background-position: center;
    background-size: cover;
}

.actionPlanContainer-toyota .accessories_icon {
    height: 40px;
    width: 40px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
    background-repeat: no-repeat;
    margin-left: 18px !important;
    background-position: center;
    background-size: cover;
}

.actionPlanContainer-lexus .accessories_icon {
    height: 40px;
    width: 40px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
    background-repeat: no-repeat;
    margin-left: 18px !important;
    background-position: center;
    background-size: cover;
}

.actionPlanContainer-toyota .walk_around_check_icon {
    height: 40px;
    width: 40px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
    background-repeat: no-repeat;
    margin-left: 18px !important;
    background-position: center;
    background-size: cover;
    float: left;
}

.actionPlanContainer-lexus .walk_around_check_icon {
    height: 40px;
    width: 40px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
    background-repeat: no-repeat;
    margin-left: 18px !important;
    background-position: center;
    background-size: cover;
    float: left;
}

.actionPlanContainer-toyota .maintenance_reminders_icon {
    height: 40px;
    width: 40px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
    background-repeat: no-repeat;
    margin-left: 18px !important;
    background-position: center;
    background-size: cover;
}

.actionPlanContainer-lexus .maintenance_reminders_icon {
    height: 40px;
    width: 40px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
    background-repeat: no-repeat;
    margin-left: 18px !important;
    background-position: center;
    background-size: cover;
}

.actionPlanContainer-toyota .fix_it_right_icon {
    height: 40px;
    width: 40px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
    background-repeat: no-repeat;
    margin-left: 18px !important;
    background-position: center;
    background-size: cover;
}

.actionPlanContainer-lexus .fix_it_right_icon {
    height: 40px;
    width: 40px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
    background-repeat: no-repeat;
    margin-left: 18px !important;
    background-position: center;
    background-size: cover;
}

.actionPlanContainer-toyota .efficiency_icon {
    height: 40px;
    width: 40px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
    background-repeat: no-repeat;
    margin-left: 18px !important;
    background-position: center;
    background-size: cover;
}

.actionPlanContainer-lexus .efficiency_icon {
    height: 40px;
    width: 40px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
    background-repeat: no-repeat;
    margin-left: 18px !important;
    background-position: center;
    background-size: cover;
}

.actionPlanContainer-toyota .dpok_icon {
    height: 40px;
    width: 40px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
    background-repeat: no-repeat;
    margin-left: 18px !important;
    background-position: center;
    background-size: cover;
}

.actionPlanContainer-lexus .dpok_icon {
    height: 40px;
    width: 40px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
    background-repeat: no-repeat;
    margin-left: 18px !important;
    background-position: center;
    background-size: cover;
}

.FileDownload:hover {
    border-bottom: solid 1px;
    font-size: 1rem;
}

.downloadContainer {
    background: rgba(255, 255, 255, 0.7);
    margin: 2px;
}

.downloadContainer:hover {
    background: rgb(255, 255, 255);
}

.actionPlanContainer-toyota .active {
    border-bottom: #E50000 2px solid !important;
}

.actionPlanContainer-lexus .active {
    border-bottom: #252525 2px solid !important;
}

.activityTabs .nav-link {
    margin-left: 2px !important;
}

.activityTabs .tab-content {
    background-color: #f0f0f0;
}

.activityTabs tbody tr {
    border-bottom: 5px solid #f0f0f0 !important
}

/* .table>thead>tr>th {
    padding-bottom: 1rem
} */

.actionPlanContainer-toyota .toyota_way_icon {
    height: 40px;
    width: 40px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
    background-repeat: no-repeat;
    margin-left: 18px !important;
    background-position: center;
    background-size: cover;
}

.actionPlanContainer-lexus .toyota_way_icon {
    height: 40px;
    width: 40px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
    background-repeat: no-repeat;
    margin-left: 18px !important;
    background-position: center;
    background-size: cover;
}

.actionPlanContainer-toyota .customer_centricity_icon {
    height: 40px;
    width: 40px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
    background-repeat: no-repeat;
    margin-left: 18px !important;
    background-position: center;
    background-size: cover;
}

.actionPlanContainer-lexus .customer_centricity_icon {
    height: 40px;
    width: 40px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
    background-repeat: no-repeat;
    margin-left: 18px !important;
    background-position: center;
    background-size: cover;
}

.actionPlanContainer-toyota .employee_engagement_icon {
    height: 40px;
    width: 40px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
    background-repeat: no-repeat;
    margin-left: 18px !important;
    background-position: center;
    background-size: cover;
}

.actionPlanContainer-lexus .employee_engagement_icon {
    height: 40px;
    width: 40px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
    background-repeat: no-repeat;
    margin-left: 18px !important;
    background-position: center;
    background-size: cover;
}

.actionPlanContainer-toyota .business_sustainability_icon {
    height: 40px;
    width: 40px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_21___});
    background-repeat: no-repeat;
    margin-left: 18px !important;
    background-position: center;
    background-size: cover;
}

.actionPlanContainer-lexus .business_sustainability_icon {
    height: 40px;
    width: 40px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_22___});
    background-repeat: no-repeat;
    margin-left: 18px !important;
    background-position: center;
    background-size: cover;
}

.actionPlanContainer-toyota_icon {
    height: 40px;
    width: 40px;
    background-repeat: no-repeat;
    margin-left: 18px !important;
    background-position: center;
    background-size: cover;
    float: left;
}

.actionPlanContainer-lexus_icon  {
    height: 40px;
    width: 40px;
    background-repeat: no-repeat;
    margin-left: 18px !important;
    background-position: center;
    background-size: cover;
    float: left;
}

.lexus-Assign-FontWithBold {
    float: left;
    color: #252525;
    font-weight: bold;
    padding-left: 0.5rem !important;
    padding-top: 0.2rem;
    margin-top: 0.2rem;
}

.toyota-Assign-FontWithBold {
    float: left;
    color: #e50000;
    font-weight: bold;
    padding-left: 0.5rem !important;
    padding-top: 0.2rem;
    margin-top: 0.2rem;
}

.linkFilterLabel{
    padding-left: 0rem;
    /* width: 9rem;  */
    margin : 5px 60px 5px 0px;
}

.linkFilter {
    padding: 1rem;
    border-left: 6px solid;
    border-left-color: #e50000;
    border-right: 6px solid;
    border-right-color: #e50000;
    border-top: 1px solid;
    border-top-color: #000000;
    border-bottom: 1px solid;
    border-bottom-color: #000000;
    background-color: rgba(247, 247, 247, 1) ;
}


.linkFilter .noPadding {
    padding: 0px;
}

.linkFilter-toyota .css-10nd86i svg {
    color: #e50000;
}

.linkFilter-lexus .css-10nd86i svg {
    color: #252525;
}

/* .linkFilter .css-1492t68 {
    text-indent: -9999px;
} */

.linkFilter .css-va7pk8 {
    color: #595d60 !important;
}

.Select-menu-outer {
    max-height: 1000px;
}

.Select-menu {
    max-height: 998px;
}

.bigDD-toyota .css-1r4vtzz, .bigDD-toyota .css-48ayfv, .bigDD-lexus .css-1r4vtzz, .bigDD-lexus .css-48ayfv {
    width: 11.7rem;
}

.bigDD-toyota .css-1r4vtzz svg, .bigDD-toyota .css-48ayfv svg{
    color: #e50000 !important;
}

.bigDD-lexus .css-1r4vtzz svg, .bigDD-lexus .css-48ayfv svg{
    color: #252525 !important;
}



.linkFilter-toyota .css-11unzgr{
    max-height: 170px !important;
}


.linkFilter-lexus .css-11unzgr{
    max-height: 170px !important;
}

.linkFilter-toyota .css-ivrpdj{
    max-height: 170px !important;
}


.linkFilter-lexus .css-ivrpdj{
    max-height: 170px !important;
}

.smallDD-toyota .css-1r4vtzz svg, .smallDD-toyota .css-48ayfv svg{
    color: #e50000 !important;
}

.smallDD-lexus .css-1r4vtzz svg, .smallDD-lexus .css-48ayfv svg{
    color: #252525 !important;
}

.smallDD-toyota .css-1r4vtzz, .smallDD-toyota .css-48ayfv, .smallDD-toyota .react-datepicker__input-container, .smallDD-lexus .css-1r4vtzz, .smallDD-lexus .css-48ayfv, .smallDD-lexus .react-datepicker__input-container {
    width: 9rem;
}

.linkFilter .react-autosuggest__container {
    position: relative;
}
.assignCard{
    overflow: visible !important;
}

.linkFilter .react-autosuggest__input {
    padding: 10px 10px;
    border: 1px solid #aaa;
    border-color: rgb(219, 212, 212);
    border-radius: 0.25rem !important;
    height: calc(2.25rem + 2px);
    width: 11.7rem;

}


.linkFilter .react-autosuggest__input--open {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    border-radius: 0.25rem !important;
    height: calc(2.25rem + 2px);
    width: 11.7rem;
    
}

.linkFilter .react-autosuggest__suggestions-container--open {
    display: block;
    min-width: 11.7rem;
    border: 1px solid #aaa;
    border-radius: 0.25rem !important;
}

.linkFilter .react-autosuggest__suggestions-list {
    margin: 0;
    padding: 0;
    max-height: 200px !important;
    overflow-y: auto;
    list-style-type: none;
}

.linkFilter .react-autosuggest__suggestion {
    cursor: pointer;
    padding: 10px 20px;
    background-color: white;
}

.linkFilter .react-autosuggest__suggestion--highlighted {
    background-color: #ddd;
}

#react-autowhatever-1 {
    position: absolute;
    z-index: 9999;
    background: white;
}

.css-15brt4p {
    display: none !important;
}


 
.css-11unzgr {
    border: 0.5px solid #aaa !important;
}


.linkFilter .css-ssi0ig-container{
    width: 11.7rem;
}

.linkFormControl{
    background-color: hsl(0,0%,95%) !important;
}

.activeField-toyota .css-1wy0on6 svg{
    color: #e50000 ;
}

.activeField-lexus .css-1wy0on6 svg{
    color: #252525 ;
}


.disabledField .css-1wy0on6 div svg{
    color: rgb(204,204,204);
}

.noPadding {
    padding: 0px !important;
    margin: 0px !important;
}

.parent-toyota #pageDropDown {
    background-color: #E50000 !important;
}

.parent-lexus #pageDropDown {
    background-color: #252525 !important;
}


.parent-toyota .pagination .active>a {
    background-color: #E50000 !important;
}

.parent-lexus .pagination .active>a {
    background-color: #252525 !important;
}

.linkDealerTable tbody, .linkDealerTable tr {
    display: block;
}

.linkDealerTable tr:after {
    content: ' ';
    display: block;
    visibility: hidden;
    clear: both;
}

.linkDealerTable tbody {
    height: 54vh;
    overflow-y: scroll;
}

.linkDealerTable table {
    border-spacing: 3px 7px;
    border-collapse: separate;
    margin-bottom: 0px !important;
}

.linkDealerTable tbody>tr>td {
    /* width: 7rem; */
    float: left;
    text-overflow: ellipsis;
    overflow: hidden;
}

.linkDealerTable thead>tr>th {
    width: 7rem;
    float: left;
}

div.linkDealerTable div.row.react-bootstrap-table-pagination div {
    padding: 0px !important;
}

.activityContainer {
    font-size: 0.81rem;
    font-family: "Arial", sans-serif;
    max-width: none !important;
    margin-bottom: 3rem;
}

.activityTableContainer .tab-content {
    border-bottom-right-radius: 1.25rem;
    border-bottom-left-radius: 1.25rem;
    border-top-right-radius: 1.25rem;
    background-color: #f0f0f0;
    padding: 1.25rem;
    /* height: 33rem;
    width: 81.5rem; */
}

.listDealerContainer{
    font-size: 0.81rem;
    font-family: "Arial", sans-serif;
    max-width: none !important;
    margin-bottom: 0rem !important;
    padding: 0px !important;
}

.activityTableContainer .activity-content {
    border-bottom-right-radius: 1.25rem;
    border-bottom-left-radius: 1.25rem;
    border-top-right-radius: 1.25rem;
    border-top-left-radius: 1.25rem;
    background-color: #f0f0f0;
    /* width: 81.5rem; */
}


.activity-content input {
    border-radius: 0.25rem !important;
}

span.order span.dropdown {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_23___});
    width: 16px;
    height: 20px;
    float: left;
    background-position: center;
    position: absolute;
    background-size: 80px 60px;
    visibility: hidden;
}

span.order span.dropup {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_24___});
    width: 16px;
    height: 20px;
    float: left;
    position: absolute;
    background-position: center;
    background-size: 80px 60px;
    visibility: hidden;
}


.listDealerContainer{
    margin: 0px;
}


.cardPadding{
    padding: 0.25rem !important;
}

.linkDealerTable .dropdown-menu {
    top: -18px;
    left: 104px;
    font-size: 15px;
}


.modal-title {
    color: white;
    font-size: 1.0rem !important;
    padding-left: 0.5rem;
}

.modal-header .close {
    color: white;
    padding: 1.5rem !important;
    margin: -1.3rem -1rem -2rem auto !important;
}

.viewListDealerModal {
    max-width: 38rem !important;
}

.viewListDealerModal-toyota .modal-dialog, .viewListDealerModal-toyota .modal-content {
    border-radius: 24px !important;
    border: 1px solid #e50000 !important;
}

.viewListDealerModal-lexus .modal-dialog, .viewListDealerModal-lexus .modal-content {
    border-radius: 24px !important;
    border: 1px solid #252525 !important;
}

.viewListDealerModal-toyota .modal-header {
    background-color: #e50000;
    border-top-left-radius: 20px !important;
    border-top-right-radius: 20px !important;
    padding: 0.5rem !important;
}

.viewListDealerModal-lexus .modal-header {
    background-color: #252525;
    border-top-left-radius: 20px !important;
    border-top-right-radius: 20px !important;
    padding: 0.5rem !important;
}


.viewListDealerModal .css-10nd86i svg {
    color: #e50000;
}

/* .viewListDealerModal .css-10nd86i .css-1492t68 {
    text-indent: -9999px;
} */

.viewListDealerModal .css-va7pk8 {
    color: #595d60 !important;
}

.viewListDealerModal .modal-body {
    font-size: 0.81rem;
    color: #595d60;
    padding: 10px !important;
    padding-top: 15px !important;
}

/* .viewListDealerModal textarea.form-control {
    height: calc(2.25rem + 2px);
} */

.viewListDealerModal .modal-content {
    width: 38rem;
}

.viewListDealerModal li {
    float: left !important;
    vertical-align: middle;
    width: 100% !important;
}

.viewListDealerModal li>.nav-link {
    border: none !important;
    text-align: right;
}

.viewListDealerModal-toyota li>.nav-link.active {
    -background-color: red;
    color: #e50000;
}

.viewListDealerModal-lexus li>.nav-link.active {
    -background-color: #252525;
    color: #252525;
}

.viewListDealerModal-toyota li>.nav-link:focus, .viewListDealerModal-toyota li>.nav-link:hover {
    color: #e50000 !important;
}

.viewListDealerModal-lexus li>.nav-link:focus, .viewListDealerModal-lexus li>.nav-link:hover {
    color: #252525 !important;
}


.viewListDealerModal .col-md-3 {
    max-width: 30%;
}`, "",{"version":3,"sources":["webpack://./src/components/linkDealer/index.css"],"names":[],"mappings":"AAAA;IACI,4BAA4B;IAC5B,2BAA2B;IAC3B,6BAA6B;IAC7B,kBAAkB;IAClB,gCAAgC;IAChC,0BAA0B;AAC9B;;AAEA;IACI,2BAA2B;IAC3B,4BAA4B;IAC5B,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,iBAAiB;AACrB;;;AAGA;IACI,qBAAqB;AACzB;;AAEA;IACI,mCAAmC;IACnC,kCAAkC;IAClC,gCAAgC;IAChC,yBAAyB;IACzB,gBAAgB;IAChB,WAAW;IACX,WAAW;IACX,kCAAkC;AACtC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,yDAAsD;IACtD,YAAY;IACZ,WAAW;IACX,2BAA2B;IAC3B,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,yDAA8D;IAC9D,4BAA4B;IAC5B,4BAA4B;IAC5B,2BAA2B;IAC3B,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,yDAA0D;IAC1D,4BAA4B;IAC5B,4BAA4B;IAC5B,2BAA2B;IAC3B,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,yDAA+D;IAC/D,4BAA4B;IAC5B,4BAA4B;IAC5B,2BAA2B;IAC3B,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,yDAA2D;IAC3D,4BAA4B;IAC5B,4BAA4B;IAC5B,2BAA2B;IAC3B,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,yDAA8D;IAC9D,4BAA4B;IAC5B,4BAA4B;IAC5B,2BAA2B;IAC3B,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,yDAA0D;IAC1D,4BAA4B;IAC5B,4BAA4B;IAC5B,2BAA2B;IAC3B,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,yDAAuE;IACvE,4BAA4B;IAC5B,4BAA4B;IAC5B,2BAA2B;IAC3B,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,yDAAmE;IACnE,4BAA4B;IAC5B,4BAA4B;IAC5B,2BAA2B;IAC3B,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,yDAA8D;IAC9D,4BAA4B;IAC5B,4BAA4B;IAC5B,2BAA2B;IAC3B,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,0DAA0D;IAC1D,4BAA4B;IAC5B,4BAA4B;IAC5B,2BAA2B;IAC3B,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,0DAA8D;IAC9D,4BAA4B;IAC5B,4BAA4B;IAC5B,2BAA2B;IAC3B,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,0DAA0D;IAC1D,4BAA4B;IAC5B,4BAA4B;IAC5B,2BAA2B;IAC3B,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,0DAAwD;IACxD,4BAA4B;IAC5B,4BAA4B;IAC5B,2BAA2B;IAC3B,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,0DAAoD;IACpD,4BAA4B;IAC5B,4BAA4B;IAC5B,2BAA2B;IAC3B,sBAAsB;AAC1B;;AAEA;IACI,wBAAwB;IACxB,eAAe;AACnB;;AAEA;IACI,oCAAoC;IACpC,WAAW;AACf;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI;AACJ;;AAEA;;GAEG;;AAEH;IACI,YAAY;IACZ,WAAW;IACX,0DAA8D;IAC9D,4BAA4B;IAC5B,4BAA4B;IAC5B,2BAA2B;IAC3B,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,0DAA0D;IAC1D,4BAA4B;IAC5B,4BAA4B;IAC5B,2BAA2B;IAC3B,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,0DAAuE;IACvE,4BAA4B;IAC5B,4BAA4B;IAC5B,2BAA2B;IAC3B,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,0DAAmE;IACnE,4BAA4B;IAC5B,4BAA4B;IAC5B,2BAA2B;IAC3B,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,0DAAuE;IACvE,4BAA4B;IAC5B,4BAA4B;IAC5B,2BAA2B;IAC3B,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,0DAAmE;IACnE,4BAA4B;IAC5B,4BAA4B;IAC5B,2BAA2B;IAC3B,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,0DAA2E;IAC3E,4BAA4B;IAC5B,4BAA4B;IAC5B,2BAA2B;IAC3B,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,0DAAuE;IACvE,4BAA4B;IAC5B,4BAA4B;IAC5B,2BAA2B;IAC3B,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,4BAA4B;IAC5B,4BAA4B;IAC5B,2BAA2B;IAC3B,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,4BAA4B;IAC5B,4BAA4B;IAC5B,2BAA2B;IAC3B,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,cAAc;IACd,iBAAiB;IACjB,+BAA+B;IAC/B,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,iBAAiB;IACjB,+BAA+B;IAC/B,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,0BAA0B;IAC1B,uBAAuB;IACvB,2BAA2B;IAC3B,qBAAqB;IACrB,yBAAyB;IACzB,wBAAwB;IACxB,4BAA4B;IAC5B,yCAAyC;AAC7C;;;AAGA;IACI,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;;GAEG;;AAEH;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;;;AAIA;IACI,4BAA4B;AAChC;;;AAGA;IACI,4BAA4B;AAChC;;AAEA;IACI,4BAA4B;AAChC;;;AAGA;IACI,4BAA4B;AAChC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB;AACA;IACI,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,gCAAgC;IAChC,iCAAiC;IACjC,2BAA2B;IAC3B,cAAc;;AAElB;;;AAGA;IACI,4BAA4B;IAC5B,6BAA6B;IAC7B,iCAAiC;IACjC,2BAA2B;IAC3B,cAAc;;AAElB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,sBAAsB;IACtB,iCAAiC;AACrC;;AAEA;IACI,SAAS;IACT,UAAU;IACV,4BAA4B;IAC5B,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,wBAAwB;AAC5B;;;;AAIA;IACI,mCAAmC;AACvC;;;AAGA;IACI,cAAc;AAClB;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;;AAGA;IACI,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;;AAGA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,yBAAyB;IACzB,6BAA6B;AACjC;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,WAAW;AACf;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,gCAAgC;IAChC,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA;IACI,mCAAmC;IACnC,kCAAkC;IAClC,gCAAgC;IAChC,yBAAyB;IACzB,gBAAgB;IAChB;qBACiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,gCAAgC;IAChC,0BAA0B;IAC1B,8BAA8B;IAC9B,uBAAuB;AAC3B;;AAEA;IACI,mCAAmC;IACnC,kCAAkC;IAClC,gCAAgC;IAChC,+BAA+B;IAC/B,yBAAyB;IACzB,oBAAoB;AACxB;;;AAGA;IACI,iCAAiC;AACrC;;AAEA;IACI,0DAAgE;IAChE,WAAW;IACX,YAAY;IACZ,WAAW;IACX,2BAA2B;IAC3B,kBAAkB;IAClB,0BAA0B;IAC1B,kBAAkB;AACtB;;AAEA;IACI,0DAA8D;IAC9D,WAAW;IACX,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,2BAA2B;IAC3B,0BAA0B;IAC1B,kBAAkB;AACtB;;;AAGA;IACI,WAAW;AACf;;;AAGA;IACI,2BAA2B;AAC/B;;AAEA;IACI,UAAU;IACV,WAAW;IACX,eAAe;AACnB;;;AAGA;IACI,YAAY;IACZ,4BAA4B;IAC5B,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ,0BAA0B;IAC1B,2CAA2C;AAC/C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,8BAA8B;IAC9B,oCAAoC;AACxC;;AAEA;IACI,8BAA8B;IAC9B,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;IACzB,uCAAuC;IACvC,wCAAwC;IACxC,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;IACzB,uCAAuC;IACvC,wCAAwC;IACxC,0BAA0B;AAC9B;;;AAGA;IACI,cAAc;AAClB;;AAEA;;GAEG;;AAEH;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,wBAAwB;IACxB,4BAA4B;AAChC;;AAEA;;GAEG;;AAEH;IACI,YAAY;AAChB;;AAEA;IACI,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,0BAA0B;IAC1B,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;;AAGA;IACI,cAAc;AAClB","sourcesContent":[".actionPlanContainer {\n    margin-right: 0px !important;\n    margin-left: 0px !important;\n    margin-top: 1.7rem !important;\n    font-size: 0.81rem;\n    font-family: \"Arial\", sans-serif;\n    max-width: none !important;\n}\n\n.activityDiv {\n    background-position: center;\n    background-repeat: no-repeat;\n    background-size: cover;\n    background-color: #F7F7F7;\n}\n\n.activityTabsHeader {\n    color: black;\n}\n\n.activityTabsHeaderRed {\n    padding-top: 1rem;\n    /* margin-bottom:2rem;  */\n}\n\n.nav-tabs>li:first-child>a {\n    border-top-left-radius: 1.25rem !important;\n}\n\n.nav-tabs>li:last-child>a {\n    border-top-right-radius: 1.25rem !important;\n}\n\n.selectedCriteria {\n    font-weight: bold;\n}\n\n\n.activityTabs .nav-item {\n    width: 18% !important;\n}\n\n.activityTabs .tab-content {\n    border-bottom-right-radius: 1.25rem;\n    border-bottom-left-radius: 1.25rem;\n    border-top-right-radius: 1.25rem;\n    background-color: #f0f0f0;\n    padding: 1.25rem;\n    width: 100%;\n    float: left;\n    /*background: rgb(212, 210, 210);*/\n}\n\n.activityTabs .nav-tabs {\n    opacity: 0.8;\n}\n\n.edit-icon-white {\n    background-image: url(\"../../assets/images//edit.png\");\n    height: 28px;\n    width: 28px;\n    background-position: center;\n    background-repeat: no-repeat;\n    margin: 0 0.3rem;\n}\n\n.actionPlanContainer-toyota .foundation_icon {\n    height: 40px;\n    width: 40px;\n    background-image: url(../../assets/images//foundation_red.png);\n    background-repeat: no-repeat;\n    margin-left: 18px !important;\n    background-position: center;\n    background-size: cover;\n}\n\n.actionPlanContainer-lexus .foundation_icon {\n    height: 40px;\n    width: 40px;\n    background-image: url(../../assets/images//foundation.png);\n    background-repeat: no-repeat;\n    margin-left: 18px !important;\n    background-position: center;\n    background-size: cover;\n}\n\n.actionPlanContainer-toyota .accessories_icon {\n    height: 40px;\n    width: 40px;\n    background-image: url(../../assets/images//accessories_red.png);\n    background-repeat: no-repeat;\n    margin-left: 18px !important;\n    background-position: center;\n    background-size: cover;\n}\n\n.actionPlanContainer-lexus .accessories_icon {\n    height: 40px;\n    width: 40px;\n    background-image: url(../../assets/images//accessories.png);\n    background-repeat: no-repeat;\n    margin-left: 18px !important;\n    background-position: center;\n    background-size: cover;\n}\n\n.actionPlanContainer-toyota .walk_around_check_icon {\n    height: 40px;\n    width: 40px;\n    background-image: url(../../assets/images//walkAround_red.png);\n    background-repeat: no-repeat;\n    margin-left: 18px !important;\n    background-position: center;\n    background-size: cover;\n    float: left;\n}\n\n.actionPlanContainer-lexus .walk_around_check_icon {\n    height: 40px;\n    width: 40px;\n    background-image: url(../../assets/images//walkAround.png);\n    background-repeat: no-repeat;\n    margin-left: 18px !important;\n    background-position: center;\n    background-size: cover;\n    float: left;\n}\n\n.actionPlanContainer-toyota .maintenance_reminders_icon {\n    height: 40px;\n    width: 40px;\n    background-image: url(../../assets/images//maintenanceReminder_red.png);\n    background-repeat: no-repeat;\n    margin-left: 18px !important;\n    background-position: center;\n    background-size: cover;\n}\n\n.actionPlanContainer-lexus .maintenance_reminders_icon {\n    height: 40px;\n    width: 40px;\n    background-image: url(../../assets/images//maintenanceReminder.png);\n    background-repeat: no-repeat;\n    margin-left: 18px !important;\n    background-position: center;\n    background-size: cover;\n}\n\n.actionPlanContainer-toyota .fix_it_right_icon {\n    height: 40px;\n    width: 40px;\n    background-image: url(../../assets/images//fixItRight_red.png);\n    background-repeat: no-repeat;\n    margin-left: 18px !important;\n    background-position: center;\n    background-size: cover;\n}\n\n.actionPlanContainer-lexus .fix_it_right_icon {\n    height: 40px;\n    width: 40px;\n    background-image: url(../../assets/images//fixItRight.png);\n    background-repeat: no-repeat;\n    margin-left: 18px !important;\n    background-position: center;\n    background-size: cover;\n}\n\n.actionPlanContainer-toyota .efficiency_icon {\n    height: 40px;\n    width: 40px;\n    background-image: url(../../assets/images//efficiency_red.png);\n    background-repeat: no-repeat;\n    margin-left: 18px !important;\n    background-position: center;\n    background-size: cover;\n}\n\n.actionPlanContainer-lexus .efficiency_icon {\n    height: 40px;\n    width: 40px;\n    background-image: url(../../assets/images//efficiency.png);\n    background-repeat: no-repeat;\n    margin-left: 18px !important;\n    background-position: center;\n    background-size: cover;\n}\n\n.actionPlanContainer-toyota .dpok_icon {\n    height: 40px;\n    width: 40px;\n    background-image: url(../../assets/images//dpok_red.png);\n    background-repeat: no-repeat;\n    margin-left: 18px !important;\n    background-position: center;\n    background-size: cover;\n}\n\n.actionPlanContainer-lexus .dpok_icon {\n    height: 40px;\n    width: 40px;\n    background-image: url(../../assets/images//dpok.png);\n    background-repeat: no-repeat;\n    margin-left: 18px !important;\n    background-position: center;\n    background-size: cover;\n}\n\n.FileDownload:hover {\n    border-bottom: solid 1px;\n    font-size: 1rem;\n}\n\n.downloadContainer {\n    background: rgba(255, 255, 255, 0.7);\n    margin: 2px;\n}\n\n.downloadContainer:hover {\n    background: rgb(255, 255, 255);\n}\n\n.actionPlanContainer-toyota .active {\n    border-bottom: #E50000 2px solid !important;\n}\n\n.actionPlanContainer-lexus .active {\n    border-bottom: #252525 2px solid !important;\n}\n\n.activityTabs .nav-link {\n    margin-left: 2px !important;\n}\n\n.activityTabs .tab-content {\n    background-color: #f0f0f0;\n}\n\n.activityTabs tbody tr {\n    border-bottom: 5px solid #f0f0f0 !important\n}\n\n/* .table>thead>tr>th {\n    padding-bottom: 1rem\n} */\n\n.actionPlanContainer-toyota .toyota_way_icon {\n    height: 40px;\n    width: 40px;\n    background-image: url(../../assets/images//toyota_way_red.png);\n    background-repeat: no-repeat;\n    margin-left: 18px !important;\n    background-position: center;\n    background-size: cover;\n}\n\n.actionPlanContainer-lexus .toyota_way_icon {\n    height: 40px;\n    width: 40px;\n    background-image: url(../../assets/images//toyota_way.png);\n    background-repeat: no-repeat;\n    margin-left: 18px !important;\n    background-position: center;\n    background-size: cover;\n}\n\n.actionPlanContainer-toyota .customer_centricity_icon {\n    height: 40px;\n    width: 40px;\n    background-image: url(../../assets/images//customer_centricity_red.png);\n    background-repeat: no-repeat;\n    margin-left: 18px !important;\n    background-position: center;\n    background-size: cover;\n}\n\n.actionPlanContainer-lexus .customer_centricity_icon {\n    height: 40px;\n    width: 40px;\n    background-image: url(../../assets/images//customer_centricity.png);\n    background-repeat: no-repeat;\n    margin-left: 18px !important;\n    background-position: center;\n    background-size: cover;\n}\n\n.actionPlanContainer-toyota .employee_engagement_icon {\n    height: 40px;\n    width: 40px;\n    background-image: url(../../assets/images//employee_engagement_red.png);\n    background-repeat: no-repeat;\n    margin-left: 18px !important;\n    background-position: center;\n    background-size: cover;\n}\n\n.actionPlanContainer-lexus .employee_engagement_icon {\n    height: 40px;\n    width: 40px;\n    background-image: url(../../assets/images//employee_engagement.png);\n    background-repeat: no-repeat;\n    margin-left: 18px !important;\n    background-position: center;\n    background-size: cover;\n}\n\n.actionPlanContainer-toyota .business_sustainability_icon {\n    height: 40px;\n    width: 40px;\n    background-image: url(../../assets/images//business_sustainability_red.png);\n    background-repeat: no-repeat;\n    margin-left: 18px !important;\n    background-position: center;\n    background-size: cover;\n}\n\n.actionPlanContainer-lexus .business_sustainability_icon {\n    height: 40px;\n    width: 40px;\n    background-image: url(../../assets/images//business_sustainability.png);\n    background-repeat: no-repeat;\n    margin-left: 18px !important;\n    background-position: center;\n    background-size: cover;\n}\n\n.actionPlanContainer-toyota_icon {\n    height: 40px;\n    width: 40px;\n    background-repeat: no-repeat;\n    margin-left: 18px !important;\n    background-position: center;\n    background-size: cover;\n    float: left;\n}\n\n.actionPlanContainer-lexus_icon  {\n    height: 40px;\n    width: 40px;\n    background-repeat: no-repeat;\n    margin-left: 18px !important;\n    background-position: center;\n    background-size: cover;\n    float: left;\n}\n\n.lexus-Assign-FontWithBold {\n    float: left;\n    color: #252525;\n    font-weight: bold;\n    padding-left: 0.5rem !important;\n    padding-top: 0.2rem;\n    margin-top: 0.2rem;\n}\n\n.toyota-Assign-FontWithBold {\n    float: left;\n    color: #e50000;\n    font-weight: bold;\n    padding-left: 0.5rem !important;\n    padding-top: 0.2rem;\n    margin-top: 0.2rem;\n}\n\n.linkFilterLabel{\n    padding-left: 0rem;\n    /* width: 9rem;  */\n    margin : 5px 60px 5px 0px;\n}\n\n.linkFilter {\n    padding: 1rem;\n    border-left: 6px solid;\n    border-left-color: #e50000;\n    border-right: 6px solid;\n    border-right-color: #e50000;\n    border-top: 1px solid;\n    border-top-color: #000000;\n    border-bottom: 1px solid;\n    border-bottom-color: #000000;\n    background-color: rgba(247, 247, 247, 1) ;\n}\n\n\n.linkFilter .noPadding {\n    padding: 0px;\n}\n\n.linkFilter-toyota .css-10nd86i svg {\n    color: #e50000;\n}\n\n.linkFilter-lexus .css-10nd86i svg {\n    color: #252525;\n}\n\n/* .linkFilter .css-1492t68 {\n    text-indent: -9999px;\n} */\n\n.linkFilter .css-va7pk8 {\n    color: #595d60 !important;\n}\n\n.Select-menu-outer {\n    max-height: 1000px;\n}\n\n.Select-menu {\n    max-height: 998px;\n}\n\n.bigDD-toyota .css-1r4vtzz, .bigDD-toyota .css-48ayfv, .bigDD-lexus .css-1r4vtzz, .bigDD-lexus .css-48ayfv {\n    width: 11.7rem;\n}\n\n.bigDD-toyota .css-1r4vtzz svg, .bigDD-toyota .css-48ayfv svg{\n    color: #e50000 !important;\n}\n\n.bigDD-lexus .css-1r4vtzz svg, .bigDD-lexus .css-48ayfv svg{\n    color: #252525 !important;\n}\n\n\n\n.linkFilter-toyota .css-11unzgr{\n    max-height: 170px !important;\n}\n\n\n.linkFilter-lexus .css-11unzgr{\n    max-height: 170px !important;\n}\n\n.linkFilter-toyota .css-ivrpdj{\n    max-height: 170px !important;\n}\n\n\n.linkFilter-lexus .css-ivrpdj{\n    max-height: 170px !important;\n}\n\n.smallDD-toyota .css-1r4vtzz svg, .smallDD-toyota .css-48ayfv svg{\n    color: #e50000 !important;\n}\n\n.smallDD-lexus .css-1r4vtzz svg, .smallDD-lexus .css-48ayfv svg{\n    color: #252525 !important;\n}\n\n.smallDD-toyota .css-1r4vtzz, .smallDD-toyota .css-48ayfv, .smallDD-toyota .react-datepicker__input-container, .smallDD-lexus .css-1r4vtzz, .smallDD-lexus .css-48ayfv, .smallDD-lexus .react-datepicker__input-container {\n    width: 9rem;\n}\n\n.linkFilter .react-autosuggest__container {\n    position: relative;\n}\n.assignCard{\n    overflow: visible !important;\n}\n\n.linkFilter .react-autosuggest__input {\n    padding: 10px 10px;\n    border: 1px solid #aaa;\n    border-color: rgb(219, 212, 212);\n    border-radius: 0.25rem !important;\n    height: calc(2.25rem + 2px);\n    width: 11.7rem;\n\n}\n\n\n.linkFilter .react-autosuggest__input--open {\n    border-bottom-left-radius: 0;\n    border-bottom-right-radius: 0;\n    border-radius: 0.25rem !important;\n    height: calc(2.25rem + 2px);\n    width: 11.7rem;\n    \n}\n\n.linkFilter .react-autosuggest__suggestions-container--open {\n    display: block;\n    min-width: 11.7rem;\n    border: 1px solid #aaa;\n    border-radius: 0.25rem !important;\n}\n\n.linkFilter .react-autosuggest__suggestions-list {\n    margin: 0;\n    padding: 0;\n    max-height: 200px !important;\n    overflow-y: auto;\n    list-style-type: none;\n}\n\n.linkFilter .react-autosuggest__suggestion {\n    cursor: pointer;\n    padding: 10px 20px;\n    background-color: white;\n}\n\n.linkFilter .react-autosuggest__suggestion--highlighted {\n    background-color: #ddd;\n}\n\n#react-autowhatever-1 {\n    position: absolute;\n    z-index: 9999;\n    background: white;\n}\n\n.css-15brt4p {\n    display: none !important;\n}\n\n\n \n.css-11unzgr {\n    border: 0.5px solid #aaa !important;\n}\n\n\n.linkFilter .css-ssi0ig-container{\n    width: 11.7rem;\n}\n\n.linkFormControl{\n    background-color: hsl(0,0%,95%) !important;\n}\n\n.activeField-toyota .css-1wy0on6 svg{\n    color: #e50000 ;\n}\n\n.activeField-lexus .css-1wy0on6 svg{\n    color: #252525 ;\n}\n\n\n.disabledField .css-1wy0on6 div svg{\n    color: rgb(204,204,204);\n}\n\n.noPadding {\n    padding: 0px !important;\n    margin: 0px !important;\n}\n\n.parent-toyota #pageDropDown {\n    background-color: #E50000 !important;\n}\n\n.parent-lexus #pageDropDown {\n    background-color: #252525 !important;\n}\n\n\n.parent-toyota .pagination .active>a {\n    background-color: #E50000 !important;\n}\n\n.parent-lexus .pagination .active>a {\n    background-color: #252525 !important;\n}\n\n.linkDealerTable tbody, .linkDealerTable tr {\n    display: block;\n}\n\n.linkDealerTable tr:after {\n    content: ' ';\n    display: block;\n    visibility: hidden;\n    clear: both;\n}\n\n.linkDealerTable tbody {\n    height: 54vh;\n    overflow-y: scroll;\n}\n\n.linkDealerTable table {\n    border-spacing: 3px 7px;\n    border-collapse: separate;\n    margin-bottom: 0px !important;\n}\n\n.linkDealerTable tbody>tr>td {\n    /* width: 7rem; */\n    float: left;\n    text-overflow: ellipsis;\n    overflow: hidden;\n}\n\n.linkDealerTable thead>tr>th {\n    width: 7rem;\n    float: left;\n}\n\ndiv.linkDealerTable div.row.react-bootstrap-table-pagination div {\n    padding: 0px !important;\n}\n\n.activityContainer {\n    font-size: 0.81rem;\n    font-family: \"Arial\", sans-serif;\n    max-width: none !important;\n    margin-bottom: 3rem;\n}\n\n.activityTableContainer .tab-content {\n    border-bottom-right-radius: 1.25rem;\n    border-bottom-left-radius: 1.25rem;\n    border-top-right-radius: 1.25rem;\n    background-color: #f0f0f0;\n    padding: 1.25rem;\n    /* height: 33rem;\n    width: 81.5rem; */\n}\n\n.listDealerContainer{\n    font-size: 0.81rem;\n    font-family: \"Arial\", sans-serif;\n    max-width: none !important;\n    margin-bottom: 0rem !important;\n    padding: 0px !important;\n}\n\n.activityTableContainer .activity-content {\n    border-bottom-right-radius: 1.25rem;\n    border-bottom-left-radius: 1.25rem;\n    border-top-right-radius: 1.25rem;\n    border-top-left-radius: 1.25rem;\n    background-color: #f0f0f0;\n    /* width: 81.5rem; */\n}\n\n\n.activity-content input {\n    border-radius: 0.25rem !important;\n}\n\nspan.order span.dropdown {\n    background-image: url(\"../../assets/images//Artboard 3down.png\");\n    width: 16px;\n    height: 20px;\n    float: left;\n    background-position: center;\n    position: absolute;\n    background-size: 80px 60px;\n    visibility: hidden;\n}\n\nspan.order span.dropup {\n    background-image: url(\"../../assets/images//Artboard 3up.png\");\n    width: 16px;\n    height: 20px;\n    float: left;\n    position: absolute;\n    background-position: center;\n    background-size: 80px 60px;\n    visibility: hidden;\n}\n\n\n.listDealerContainer{\n    margin: 0px;\n}\n\n\n.cardPadding{\n    padding: 0.25rem !important;\n}\n\n.linkDealerTable .dropdown-menu {\n    top: -18px;\n    left: 104px;\n    font-size: 15px;\n}\n\n\n.modal-title {\n    color: white;\n    font-size: 1.0rem !important;\n    padding-left: 0.5rem;\n}\n\n.modal-header .close {\n    color: white;\n    padding: 1.5rem !important;\n    margin: -1.3rem -1rem -2rem auto !important;\n}\n\n.viewListDealerModal {\n    max-width: 38rem !important;\n}\n\n.viewListDealerModal-toyota .modal-dialog, .viewListDealerModal-toyota .modal-content {\n    border-radius: 24px !important;\n    border: 1px solid #e50000 !important;\n}\n\n.viewListDealerModal-lexus .modal-dialog, .viewListDealerModal-lexus .modal-content {\n    border-radius: 24px !important;\n    border: 1px solid #252525 !important;\n}\n\n.viewListDealerModal-toyota .modal-header {\n    background-color: #e50000;\n    border-top-left-radius: 20px !important;\n    border-top-right-radius: 20px !important;\n    padding: 0.5rem !important;\n}\n\n.viewListDealerModal-lexus .modal-header {\n    background-color: #252525;\n    border-top-left-radius: 20px !important;\n    border-top-right-radius: 20px !important;\n    padding: 0.5rem !important;\n}\n\n\n.viewListDealerModal .css-10nd86i svg {\n    color: #e50000;\n}\n\n/* .viewListDealerModal .css-10nd86i .css-1492t68 {\n    text-indent: -9999px;\n} */\n\n.viewListDealerModal .css-va7pk8 {\n    color: #595d60 !important;\n}\n\n.viewListDealerModal .modal-body {\n    font-size: 0.81rem;\n    color: #595d60;\n    padding: 10px !important;\n    padding-top: 15px !important;\n}\n\n/* .viewListDealerModal textarea.form-control {\n    height: calc(2.25rem + 2px);\n} */\n\n.viewListDealerModal .modal-content {\n    width: 38rem;\n}\n\n.viewListDealerModal li {\n    float: left !important;\n    vertical-align: middle;\n    width: 100% !important;\n}\n\n.viewListDealerModal li>.nav-link {\n    border: none !important;\n    text-align: right;\n}\n\n.viewListDealerModal-toyota li>.nav-link.active {\n    -background-color: red;\n    color: #e50000;\n}\n\n.viewListDealerModal-lexus li>.nav-link.active {\n    -background-color: #252525;\n    color: #252525;\n}\n\n.viewListDealerModal-toyota li>.nav-link:focus, .viewListDealerModal-toyota li>.nav-link:hover {\n    color: #e50000 !important;\n}\n\n.viewListDealerModal-lexus li>.nav-link:focus, .viewListDealerModal-lexus li>.nav-link:hover {\n    color: #252525 !important;\n}\n\n\n.viewListDealerModal .col-md-3 {\n    max-width: 30%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
